<template>
    <div class="pj">
        <nodata-for-detail title="暂未评价" v-if="noData">
            <p class="fs14 mt5 flex jcc">转诊完成后，急救医护可以对此次过程做出评价</p>
        </nodata-for-detail>
        <template v-else>
            <pj-info :info="list[0]"></pj-info>
            <ul class="">
                <li class="flex aic pt20 pb20" :key="item.createTime" v-for="item in list">
                    <span>{{item.createTime|timeFilter("YYYY-MM-DD HH:mm:ss")}}</span>
                    <span class="ml30 color_main pointer" @click="change(item)">查看详情</span>
                </li>
            </ul>
        </template>

        <el-dialog title="评价详情" :visible.sync="showInfo" append-to-body>
            <pj-info :info="info"></pj-info>
        </el-dialog>
    </div>
</template>
<script>
    import {staffService} from "../../staff/service/staff";
    import NodataForDetail from "../../staff/components/nodata-for-detail";
    import {isEmpty} from "../../../common/lib/utils";
    import {timeFilter} from "../../../common/lib/filters";
    import PjInfo from "./pj-info";

    export default {
        name: "pj-table",
        filters: {timeFilter},
        components: {PjInfo, NodataForDetail},
        props: {
            id: String
        },
        data() {
            return {
                showInfo: false,
                info: {},
                list: []
            }
        },
        computed: {
            noData() {
                return isEmpty(this.list);
            }
        },
        created() {
            if (this.id) this.getData()
        },
        watch: {
            id() {
                this.getData()
            }
        },
        methods: {
            change(item) {
                this.info = item;
                this.showInfo = true
            },
            async getData() {
                this.list = await staffService.listPj(this.id);
                this.info = await staffService.detailComment(this.id);
            }
        },
    };
</script>
<style scoped lang="scss">
    td {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
